import { Injectable } from '@angular/core';
import { APIServerResponse, PageCO } from '../models/ApiModels';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';
import { SchoolMapService } from './school-map.service';

@Injectable({ providedIn: 'root' })
export class PageDataService {
  private pageDataSubject = new BehaviorSubject<PageCO[] | null>(null);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private errorSubject = new BehaviorSubject<string | null>(null);

  pageData$ = this.pageDataSubject.asObservable();
  loading$ = this.loadingSubject.asObservable();
  error$ = this.errorSubject.asObservable();

  constructor(private apiService: ApiService, private schoolMapService:SchoolMapService) {}

  loadPageData(forceReload = false): void {
    if (this.pageDataSubject.value && !forceReload) {
      return;
    }

    this.loadingSubject.next(true);
    this.errorSubject.next(null);
    // const schoolDetail = ;
    const schoolId = this.schoolMapService.getSchoolId();
    this.apiService
      .getPageDetailsBySchId(schoolId||0)
      .subscribe({
        next: (res: APIServerResponse) => {
          if (res?.statusCode === 200 && res.data) {
            this.pageDataSubject.next(res.data);
          } else {
            this.errorSubject.next(
              res?.message || 'Failed to load page data'
            );
          }
          this.loadingSubject.next(false);
        },
        error: (err) => {
          console.error('PageDataService error:', err);
          this.errorSubject.next(
            'Something went wrong. Please try again later.'
          );
          this.loadingSubject.next(false);
        }
      });
  }

  getSnapshot(): PageCO[] | null {
    return this.pageDataSubject.value;
  }
}
